import { Helmet } from "react-helmet-async";

const SITE = "Unfiltered & On-Ball";
const DEFAULT_IMG = "https://customer-assets.emergentagent.com/job_sports-press-hub/artifacts/vvwjhg0c_1775762484499.png";
const DEFAULT_DESC = "Raw takes, real perspective, from two former players who still live the game. New episode every Monday.";

export default function SEO({
  title,
  description = DEFAULT_DESC,
  image = DEFAULT_IMG,
  type = "website",
  url,
  author,
  publishedAt,
}) {
  const fullTitle = title ? `${title} · ${SITE}` : `${SITE} — Sports & Conversation`;
  const resolvedUrl = url || (typeof window !== "undefined" ? window.location.href : "");

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={resolvedUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {type === "article" && author && <meta property="article:author" content={author} />}
      {type === "article" && publishedAt && <meta property="article:published_time" content={publishedAt} />}

      <link rel="canonical" href={resolvedUrl} />
    </Helmet>
  );
}
